import PropTypes from 'prop-types';
import React from 'react';

const SelectLoadingFail = ({ prefix, suffix, onClick }) => {
  return (
    <div
      className="select-loading select-loading--fail"
      onClick={() => onClick()}
      onKeyUp={() => onClick()}
      role="button"
      tabIndex="0"
    >
      {prefix} <span className="select-loading__suffix">{suffix}</span>
    </div>
  );
};

SelectLoadingFail.propTypes = {
  prefix: PropTypes.string.isRequired,
  suffix: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SelectLoadingFail;
